import { AdminActionFilterParamType, FullAdminAction } from 'model';
import { useMemo } from 'react';
import { useSearchAdminActionsQuery } from '../api/AdminActionApi';

const sortDateAscending = (reports: FullAdminAction[]) => {
	const arrayForSort = [...reports];
	function customSort(a: FullAdminAction, b: FullAdminAction) {
		return new Date(b.created).getTime() - new Date(a.created).getTime();
	}
	return arrayForSort.sort(customSort);
};
const sortAscending = (reports: FullAdminAction[]) => {
	const arrayForSort = [...reports];
	function customSort(a: FullAdminAction, b: FullAdminAction) {
		return b.totalReports - a.totalReports;
	}
	return arrayForSort.sort(customSort);
};

const filterByDocumentType = (documentType: string, reports: FullAdminAction[]) => {
	return reports.filter(item => item.documentType === documentType);
};
const filterByReason = (reason: string, reports: FullAdminAction[]) => {
	return reports.filter(item => item.reason === reason);
};
const filterByUserId = (userid: string, reports: FullAdminAction[]) => {
	return reports.filter(item => item.user._id === userid);
};
export const useReportFilters = (reportFilterParams: AdminActionFilterParamType) => {
	const { sortBy, documentType, reason, actionTaken, dateRange, userid } = reportFilterParams;

	const {
		data: reportList,
		isLoading,
		isSuccess
	} = useSearchAdminActionsQuery({
		startDate: dateRange[0],
		endDate: dateRange[1],
		actionTaken
	});

	const { data: actionableReports } = useSearchAdminActionsQuery({
		startDate: dateRange[0],
		endDate: dateRange[1],
		actionTaken: 'created'
	});

	const FullAdminActionFeed: FullAdminAction[] = useMemo(() => {
		if (reportList) {
			let filteredReasonFeed: FullAdminAction[] = reportList;

			if (userid) {
				filteredReasonFeed = filterByUserId(userid, reportList);
			}
			if (reason && reason !== 'all') {
				filteredReasonFeed = filterByReason(reason, reportList);
			}

			let filteredFullAdminActionFeed = filteredReasonFeed;

			if (documentType === 'post' || documentType === 'comment') {
				filteredFullAdminActionFeed = filterByDocumentType(documentType, filteredFullAdminActionFeed);
			}

			if (sortBy && sortBy === 'date') {
				filteredFullAdminActionFeed = sortDateAscending(filteredFullAdminActionFeed);
			} else if (sortBy && sortBy === 'flags') {
				filteredFullAdminActionFeed = sortAscending(filteredFullAdminActionFeed);
			}
			return filteredFullAdminActionFeed;
		}
		return [];
	}, [reportList, userid, reason, documentType, sortBy]);

	const ActionableActionsFeed: FullAdminAction[] = useMemo(() => {
		if (actionableReports) {
			let filteredActionableFeed: FullAdminAction[] = actionableReports;
			if (userid) {
				filteredActionableFeed = filterByUserId(userid, actionableReports);
			}
			return filteredActionableFeed;
		}
		return [];
	}, [actionableReports, userid]);

	return {
		FullAdminActionFeed,
		ActionableActionsFeed,
		isLoading,
		isSuccess
	};
};
